import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { IoHome } from "react-icons/io5";
import { PiKeyReturnFill } from "react-icons/pi";
import { useAuth } from "../../Context/AuthContext";

import "./EilatTournamentForm.css";

const API = process.env.REACT_APP_API;

const EilatTournamentForm = ({ mode }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth(); 
  
  const [form, setForm] = useState({
    name: "",
    year: new Date().getFullYear(),
    registrationLink: "",
    facebookLink: "",
    showOnSite: true,
    showFlyer: true,
    showRegistration: true,
    showFacebook: true,
    showGallery: true,
    showPdf: true,
  });

  const [flyerFile, setFlyerFile] = useState(null);
  const [flyerPreview, setFlyerPreview] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [pdfFile, setPdfFile] = useState(null);
  
  // בעריכה – טוען נתונים מהשרת
  useEffect(() => {
    if (mode === "edit" && id) {
      (async () => {
        try {
          const res = await axios.get(`${API}/api/eilatTournaments/${id}`);
          const t = res.data;

          setForm({
            name: t.name || "",
            year: t.year ?? new Date().getFullYear(),
            registrationLink: t.registrationLink || "",
            facebookLink: t.facebookLink || "",
            showOnSite: !!t.showOnSite,
            showFlyer: !!t.showFlyer,
            showRegistration: !!t.showRegistration,
            showFacebook: !!t.showFacebook,
            showGallery: !!t.showGallery,
            showPdf: !!t.showGallery,
          });

          if (t.flyer) setFlyerPreview(`${API}${t.flyer}`);
          if (Array.isArray(t.gallery)) {
            setGallery(t.gallery.map(g => ({ src: `${API}${g}`, _id: g._id })));
          }
        } catch (err) {
          console.error("שגיאה בטעינת טורניר:", err);
          toast.error("❌ לא ניתן לטעון טורניר");
        }
      })();
    }
  }, [mode, id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const onFlyerChange = (e) => {
    const file = e.target.files[0];
    setFlyerFile(file || null);
    setFlyerPreview(file ? URL.createObjectURL(file) : null);
  };

  const onGalleryChange = (e) => {
    const files = Array.from(e.target.files || []);
    const newItems = files.map(f => ({ file: f, src: URL.createObjectURL(f) }));
    setGallery(prev => [...prev, ...newItems]);
  };

  const removeGalleryItem = (index) => {
    setGallery(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    
    Object.entries(form).forEach(([k, v]) => data.append(k, v));

    if (flyerFile) data.append("flyer", flyerFile);
    if (pdfFile) data.append("pdf", pdfFile);
    gallery.filter(g => g.file).forEach(g => data.append("gallery", g.file));

    try {
      if (mode === "add") {
        await axios.post(`${API}/api/eilatTournaments`, data, {
          headers: { 
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`   // 👈 חובה
          },
        });
        toast.success("✅ טורניר נוסף בהצלחה!");
      } else {
        await axios.put(`${API}/api/eilatTournaments/${id}`, data, {
          headers: { 
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`   // 👈 חובה
          },
        });
        toast.success("✅ טורניר עודכן בהצלחה!");
      }
      navigate("/eilatTournaments");
    } catch (err) {
      console.error("שגיאה בשמירה:", err);
      toast.error("❌ שמירת הטורניר נכשלה");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("בטוח למחוק את הטורניר?")) return;
    try {
      await axios.delete(`${API}/api/eilatTournaments/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("🗑️ טורניר נמחק");
      navigate("/eilatTournaments");
    } catch (err) {
      toast.error("❌ מחיקת הטורניר נכשלה");
    }
  };

  return (
    <div className="tournament-form-card">
      {/* אייקון הבית בפינה שמאלית עליונה */}
      <div className="home-icon">
        <IoHome title="עמוד הבית" size={30} onClick={() => navigate("/")}/>
      </div>
      <div className="back-icon">
        <PiKeyReturnFill title="חזרה לעמוד הקודם" size={40} onClick={() => navigate("/eilatTournaments")}/>
      </div>
      <h2>{mode === "add" ? "➕ הוספת טורניר חדש" : `✏️ עריכת טורניר - ${form.name}`}</h2>

      <form onSubmit={handleSubmit} className="form-grid">
        <label>שם הטורניר:
          <input type="text" name="name" value={form.name} onChange={handleChange} required />
        </label>

        <label>שנה:
          <input type="number" name="year" value={form.year || ""} onChange={handleChange} min="2000" max="2100" required />
        </label>

        <label>פלייר:
          <input type="file" accept="image/*" onChange={onFlyerChange} />
          {flyerPreview && <img src={flyerPreview} alt="preview" className="preview" />}
        </label>

        <label>חוזר רישום
        <input
          type="file" name="pdf" accept="application/pdf" onChange={(e) => setPdfFile(e.target.files[0] )}
        />
        </label>

        <label>קישור להרשמה:
          <input type="text" name="registrationLink" value={form.registrationLink} onChange={handleChange} />
        </label>

        <label>קישור לפייסבוק:
          <input type="text" name="facebookLink" value={form.facebookLink} onChange={handleChange} />
        </label>

        <label>גלריה:
          <input type="file" accept="image/*" multiple onChange={onGalleryChange} />
          {gallery.length > 0 && (
            <div className="preview-grid">
              {gallery.map((g, i) => (
                <div key={i} className="thumb">
                  <img src={g.src} alt={`g${i}`} />
                  <button type="button" onClick={() => removeGalleryItem(i)}>❌</button>
                </div>
              ))}
            </div>
          )}
        </label>

        <div className="checkbox-group">
          <label><input type="checkbox" name="showOnSite" checked={form.showOnSite} onChange={handleChange} /> מוצג באתר</label>
          <label><input type="checkbox" name="showFlyer" checked={form.showFlyer} onChange={handleChange} /> פלייר</label>
          <label><input type="checkbox" name="showPdf" checked={form.showPdf} onChange={handleChange} /> חוזר רישום</label>
          <label><input type="checkbox" name="showRegistration" checked={form.showRegistration} onChange={handleChange} /> הרשמה</label>
          <label><input type="checkbox" name="showFacebook" checked={form.showFacebook} onChange={handleChange} /> פייסבוק</label>
          <label><input type="checkbox" name="showGallery" checked={form.showGallery} onChange={handleChange} /> גלריה</label>
        </div>

        <div className="buttons">
          <button type="submit">💾 שמירה</button>
          {mode === "edit" && (
            <button type="button" onClick={handleDelete} className="delete">🗑️ מחיקה</button>
          )}
          <button type="button" onClick={() => navigate("/eilatTournaments")}>⬅️ חזרה</button>
        </div>
      </form>
    </div>
  );
};

export default EilatTournamentForm;
